// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <>
          <section
        className="hero-wrap hero-wrap-2"
        style={{ backgroundImage: "url('images/thank-you.jpg')" }}
        data-stellar-background-ratio="0.5"
      >
        <div className="overlay" />
        <div className="container">
          <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
              <h1 className="mb-3 bread">NOT FOUND</h1>
          </div>
        </div>
      </section>
         <div className="not-found-page text-center p-5">
      <h1 className="display-3">404</h1>
      <p className="lead">Oops! The page you’re looking for doesn’t exist.</p>
      <Link to="/" className="btn btn-primary mt-3">
        Go to Homepage
      </Link>
    </div>
    </>
 
  );
}
